import React, { createContext, useContext } from 'react';
import { useErrorDialog } from './error-dialog/use-error-dialog.js';

const ErrorContext = createContext(null);

export const ErrorProvider = ({ children }) => {
    const errorDialog = useErrorDialog();

    return (
        <ErrorContext.Provider value={errorDialog}>
            {children}
            <errorDialog.ErrorDialog />
        </ErrorContext.Provider>
    );
};

export const useError = () => {
    const context = useContext(ErrorContext);
    if (!context) {
        throw new Error('useError must be used within an ErrorProvider');
    }
    return context;
};